import { render, staticRenderFns } from "./captainCard.vue?vue&type=template&id=3bfda67e&scoped=true&"
import script from "./captainCard.vue?vue&type=script&lang=js&"
export * from "./captainCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfda67e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bfda67e')) {
      api.createRecord('3bfda67e', component.options)
    } else {
      api.reload('3bfda67e', component.options)
    }
    module.hot.accept("./captainCard.vue?vue&type=template&id=3bfda67e&scoped=true&", function () {
      api.rerender('3bfda67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/tracking/partials/captainCard.vue"
export default component.exports